/**
 * @description Company tax/entity types for onboarding and settings
 *
 * Key features:
 * - Same values as backend/utilities/businessTypes.js and companies.business_type CHECK
 * - Display helper so Settings/Dashboard do not title-case raw snake_case (llc → Llc)
 *
 * @dependencies
 * - None
 *
 * @notes
 * - nonprofit = IRS Form 990 tax-exempt (covers 501(c)(3) and other 990 filers)
 * - other = escape hatch when none of the named types fit
 * - Keep values in lock-step with backend VALID_BUSINESS_TYPES / migration 204
 */

export const BUSINESS_TYPES = [
  { value: 'sole_proprietorship', label: 'Sole Proprietorship' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'llc', label: 'LLC' },
  { value: 'c_corporation', label: 'C Corporation' },
  { value: 's_corporation', label: 'S Corporation' },
  { value: 'nonprofit', label: 'Nonprofit (Form 990)' },
  { value: 'other', label: 'Other' }
];

/**
 * @param {string|null|undefined} value
 * @returns {string}
 */
export function getBusinessTypeLabel(value) {
  if (!value) return '';
  const match = BUSINESS_TYPES.find((type) => type.value === value);
  if (match) return match.label;
  return value.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export default BUSINESS_TYPES;
